/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S15_HeadingInputs */

const tr_mesafeli_s15_heading = /** @type {(inputs: Mesafeli_S15_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15. Mücbir Sebepler`)
};

const en_mesafeli_s15_heading = /** @type {(inputs: Mesafeli_S15_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15. Force Majeure`)
};

const de_mesafeli_s15_heading = /** @type {(inputs: Mesafeli_S15_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15. Höhere Gewalt`)
};

const ru_mesafeli_s15_heading = /** @type {(inputs: Mesafeli_S15_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15. Обстоятельства непреодолимой силы`)
};

/**
* | output |
* | --- |
* | "15. Force Majeure" |
*
* @param {Mesafeli_S15_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s15_heading = /** @type {((inputs?: Mesafeli_S15_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S15_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s15_heading(inputs)
	if (locale === "de") return de_mesafeli_s15_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s15_heading(inputs)
	return tr_mesafeli_s15_heading(inputs)
});